import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_boyfriend: FaireProductEntity = {
  token: "apparel-socks-boyfriend",
  type: "product",
  name: "Embroidered Boyfriend Socks",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1b2f652065b299fa84b9f631f99a57f7a01e9f3e4f8c438d40da1c49e87345bd.jpeg",
  priceDollars: 7,
  msrpDollars: 16,
  freeShipping: true,
  weight: 0.2,
  dimensions: {
    width: 4,
    height: 2,
    depth: 1,
  },
  description:
    "Classic ribbed crew socks with embroidered heart detail. Soft cotton blend.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "embroidered", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
